export default __webpack_public_path__ + "static/logo-black-084b5510ef65f413924296c4e8214296.png";